import * as React from "react";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";

import { useDispatch } from "@teamprevent/admin-redux";

import { submitReferralClinicalNotes, saveReferralClinicalNotes } from "../actions";

import { questionnaireKey, ReferralClinicalNotesSections } from "./ReferralClinicalNotesSectionsV2_V3";

export const ReferralClinicalNotes = () => {
    const dispatch = useDispatch();
    const submitQuestionnaire = React.useCallback((ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[]) =>
        dispatch(submitReferralClinicalNotes(ohCaseId, taskId, customerId, questions, questionnaireKey)), [dispatch]);
    const saveQuestionnaire = React.useCallback((ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[], eTag: string) =>
        dispatch(saveReferralClinicalNotes(ohCaseId, taskId, customerId, questions, eTag)), [dispatch]);
    return (
        <ReferralClinicalNotesSections
            submitQuestionnaire={submitQuestionnaire}
            saveQuestionnaire={saveQuestionnaire}
        />
    );
};
